import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const imageServiceApi = createApi({
  reducerPath: 'imageServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
     GetImageById: builder.query<any, number>({
      query: (id) => `image/${id}`,
    })
  }),
});

export const {
  useLazyGetImageByIdQuery
} = imageServiceApi;
